/* Cove. — theme behaviour */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    var r = Math.round(cents / 100);
    return 'R' + r.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function setBag(n) {
    document.querySelectorAll('[data-bag]').forEach(function (el) { el.textContent = n; });
  }

  // ---------- Product page ----------
  var mainImg = document.getElementById('mainImg');
  if (mainImg) {
    document.querySelectorAll('.thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.thumb').forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');
        mainImg.src = btn.dataset.src;
        mainImg.alt = btn.dataset.alt;
        mainImg.style.objectFit = btn.dataset.fit;
      });
    });
  }

  var form = document.getElementById('addForm');
  if (form) {
    var price = parseInt(form.dataset.price, 10) || 0;
    var qty = 1;
    var qtyEl = form.querySelector('[data-qty]');
    var qtyInput = form.querySelector('[data-qty-input]');
    var totalEl = document.getElementById('total');
    var note = document.getElementById('addedNote');
    var addBtn = document.getElementById('addBtn');
    function draw() {
      qtyEl.textContent = qty;
      qtyInput.value = qty;
      if (totalEl) totalEl.textContent = money(qty * price);
    }
    form.querySelector('[data-inc]').addEventListener('click', function () { qty = Math.min(qty + 1, 5); note.hidden = true; draw(); });
    form.querySelector('[data-dec]').addEventListener('click', function () { qty = Math.max(qty - 1, 1); note.hidden = true; draw(); });
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // fall back to a normal form post
      e.preventDefault();
      if (addBtn) addBtn.classList.add('busy');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(form.querySelector('[name=id]').value, 10), quantity: qty }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          var text = note.querySelector('[data-note-text]');
          text.textContent = res.ok ? 'Added to your bag.' : (res.j.description || 'Sorry, that didn’t work. Please try again.');
          note.hidden = false;
          return fetch(root + 'cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) { if (cart) setBag(cart.item_count); })
        .catch(function () { form.submit(); })
        .finally(function () { if (addBtn) addBtn.classList.remove('busy'); });
    });
    draw();
  }

  // ---------- Cart page ----------
  document.querySelectorAll('[data-change]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var row = btn.closest('.bagrow');
      if (row) row.classList.add('busy');
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.change, quantity: Math.max(parseInt(btn.dataset.to, 10), 0) })
      }).then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    });
  });

  // ---------- Journal filters ----------
  var filters = document.querySelectorAll('[data-filter]');
  filters.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var f = btn.dataset.filter;
      filters.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      document.querySelectorAll('article[data-tag]').forEach(function (a) {
        a.hidden = !(f === 'all' || a.dataset.tag === f);
      });
    });
  });

  // Keep the newsletter success message in view after the page reloads
  if (/customer_posted=true/.test(location.search)) {
    var nl = document.getElementById('cove-newsletter');
    if (nl) nl.scrollIntoView({ block: 'center' });
  }
})();
